import { Record, List, Map } from 'immutable'

export const OrganizationsPermissions = Record({
  read: false,
  write: false,
  manage: false,
  manageUsers: false,
  manageChannels: false,
  manageBilling: false,
  manageIntegrations: false,
  invite: false,
  createChannel: false,
})

const OrganizationRecord = Record(
  {
    id: '',
    createdAt: 0,
    updatedAt: 0,
    name: '',
    domain: '',
    owner: null,
    members: null,
    photoURL: null,
    adminChannels: List(),
    featureFlags: null,
    membersCanInvite: true,
    membersCanAutoJoin: false,
    authMethod: null,
    authDomains: null,
    resourcesUsage: Map(),
    product: null,
    usersCount: null,
    activeUsersCount: null,
    paymentInfos: null,
    templatesChannelId: null,
    inviteToken: null,
    requiredRoleForPublicSharing: null,
    requestedManualBackupAt: null,
    requestedManualBackupBy: null,
    authProvider: null,
    automatedBackupSchedule: null,
    permissions: OrganizationsPermissions(),
  },
  'Organization'
)

class Organization extends OrganizationRecord {
  getPhotoUrl() {
    return this.photoURL
  }
}

export default Organization

export function createFromRaw(rawOrganization) {
  return new Organization(rawOrganization)
}
